<template>
  <div :class="$style.navBarContainer">
    <div :class="$style.navBarLeftGroup">
      <NuxtLink
        to="/home"
        :class="$style.navBarLogoContainer"
        aria-label="Yogen home"
      >
        <Logo :class="$style.navBarLogo" />
      </NuxtLink>
      <LogoName :class="$style.logoName" />
    </div>
    <div
      v-if="showRightGroup"
      :class="$style.navBarRightGroup"
    >
      <!--<NotificationIconComponent :class="$style.notificationIcon" />-->
      <ProfileMenu :class="$style.profileMenu" />
    </div>
  </div>
</template>

<script setup lang="ts">
  import Logo from '~/components/Logo.vue'
  import LogoName from '~/components/LogoName.vue'
  import ProfileMenu from '~/components/navBar/ProfileMenu.vue'

  interface Props {
    showRightGroup?: boolean
  }

  withDefaults(defineProps<Props>(), {
    showRightGroup: true,
  })
</script>
<style module>
  .navBarLogo {
    width: 70px;
    height: 40px;
    cursor: pointer;
  }

  .navBarContainer {
    background-color: var(--color-background-primary);
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
    height: var(--nav-bar-height);
    min-height: var(--nav-bar-height);
    border-bottom: 1px solid var(--color-border-default);
  }

  .navBarDropdown {
    width: 20vw;
  }

  .notificationIcon {
    fill: var(--color-icon-primary);
  }

  .navBarLeftGroup,
  .navBarRightGroup {
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
  }

  .navBarRightGroup {
    gap: var(--space-16);
  }

  .navBarLinkContainer {
    display: flex;
    justify-content: space-between;
    align-items: end;
    height: 100%;
  }

  .navBarLogoContainer {
    display: flex;
  }

  .logoName {
    cursor: default;
  }

  .navBarLink {
    color: var(--color-text-primary);
    text-decoration: none;
  }

  .selected .navBarLink {
    color: var(--color-interactive-link-hover);
  }

  .selected {
    border: 2px solid var(--color-interactive-primary);
    border-bottom: 4px solid var(--color-interactive-primary);
    z-index: 10;
  }

  .linkMenu {
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 10%;
    z-index: 10;
    left: 50%;
    transform: translateX(50%);
    padding: var(--space-4);
    align-items: center;
  }

  .profileMenu {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    margin-right: var(--space-8);
  }
</style>
